import React from 'react';
import { Helmet } from 'react-helmet';
import PageLayout from '../components/layout/PageLayout';
import MosquesDirectoryList from '../components/mosques/MosquesDirectoryList';

export default function MosquesPage() {
  return (
    <PageLayout title="Mosques - PakPoints">
      <Helmet>
        <title>Mosques - PakPoints</title>
        <meta
          name="description"
          content="Explore mosques and prayer facilities listed on PakPoints."
        />
      </Helmet>
      <div className="min-h-screen bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <h1 className="text-2xl font-bold text-gray-900 mb-2">Mosques</h1>
          <p className="text-gray-600 mb-6">
            Mosques shared by societies on PakPoints. Open a listing for details and directions.
          </p>
          <MosquesDirectoryList variant="default" />
        </div>
      </div>
    </PageLayout>
  );
}
